var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4H12C10.8954 4 10 4.89543 10 6V20H12C13.1046 20 14 19.1046 14 18V4ZM8 11H6C4.89543 11 4 11.8954 4 13V20H6C7.10457 20 8 19.1046 8 18V11ZM18 7H20V18C20 19.1046 19.1046 20 18 20H16V9C16 7.89543 16.8954 7 18 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChart);
export default __webpack_public_path__ + "static/media/ico-chart.c07c7239529c1ca696ab7e53f3407820.svg";
export { ForwardRef as ReactComponent };